



























import {Component, Prop, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import ScreenSizeMixin from '@/mixins/ScreenSizeMixin.vue';
import {Sync} from 'vuex-pathify';
import {nil} from '@/common';
/// <reference path="../../node_modules/@types/googlemaps/index.d.ts" />
@Component({
    components: {},
})
export default class HeroImage extends Mixins(ScreenSizeMixin) {
    public heroStyle: string = '';
    public heroHeight: number = 0;

    @Prop({default: 'https://picsum.photos/300'})
    public image!: string;

    @Prop({default: null})
    public lazy!: string | null;

    @Prop({default: ''})
    public line1!: string;

    @Prop({default: ''})
    public line2!: string;

    @Prop({default: false})
    public half!: boolean;

    @Prop({default: 1})
    public height!: number;

    @Prop({default: false})
    public locationCallToAction!: boolean;

    @Prop({default: '/book'})
    public bookPath!: string;

    @Prop({default: false})
    public alignTop!: boolean;

    @Prop({default: ''})
    public line1Style!: string;

    @Prop({default: ''})
    public line2Style!: string;

    private autocomplete!: any;

    @Sync('booking/formattedAddress') private formattedAddress?: string;
    @Sync('booking/latitude') private latitude!: number;
    @Sync('booking/longitude') private longitude!: number;
    @Sync('booking/step') private bookingStep!: number;
    public calculateHeroStyle() {
        let bg = 'background-image:';
        bg += `url('${this.image}')`;
        if (!nil(this.lazy)) {
            bg += `, url('${this.lazy}')`;
        }
        bg += ';';
        const requestedHeight: number = this.windowHeight() * this.height;
        let height = `height:${requestedHeight}px;`;
        if (this.half && this.isXS(null)) {
            height = `min-height:${requestedHeight}px;`;
        }
        const width = !this.half || !this.isMD(true)  ? `width:100%` : `width:${this.windowWidth() / 2}px;`;
        this.heroHeight = requestedHeight;
        this.heroStyle = `${bg}${height}${width}`;
    }

    public mounted() {
        this.calculateHeroStyle();
    }
    public created() {
        this.calculateHeroStyle();
    }

    @Watch('image')
    public onImageChanged(value: string, oldValue: string) {
        this.calculateHeroStyle();
    }

    @Watch('formattedAddress')
    private onLocationChanged(value: string, oldValue: string) {
        if (!nil(value) && value !== '') {
            if (this.bookingStep < 2) {
                this.bookingStep = 2;
            }
            this.$router.replace('/book');
        }
    }
}
